import { render, staticRenderFns } from "./CaixaDiario.vue?vue&type=template&id=2324d333&scoped=true&"
import script from "./CaixaDiario.vue?vue&type=script&lang=js&"
export * from "./CaixaDiario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2324d333",
  null
  
)

export default component.exports